<template>
  <div>
    <div class="table-responsive">
      <vs-table
        search
        :data="actionList"
        vs-lg="12"
        vs-sm="4"
        vs-xs="12"
        style="background-color: #f2f3f4; border-radius: 20px"
      >
        <!-- <template slot="header" >
               <div style=" margin-left: 1%; width: auto; margin-top: 1%; margin-bottom: 1%; border-radius: 5px; " >
                 <vs-dropdown >  
                 <h6 class="a-icon" href.prevent>Filters : 
                     {{ this.network }}
                  <vs-icon class icon="expand_more" size="12px"></vs-icon>
                  </h6>
                    <vs-dropdown-menu>
              <vs-dropdown-item
                v-for="item in nwlist"
                :key="item.id"
                @click="actionchange(item.id, item.name)"
              >
                {{ nwlist }}</vs-dropdown-item
              >
            </vs-dropdown-menu>
            
          </vs-dropdown></div>  
           <vs-spacer />
         
               </template> -->
        <template slot="thead">
          <vs-th
            v-for="item in header"
            :key="item"
            sort-key="name"
            style="padding: 0px"
          >
            {{ item }}
            <span><vs-icon icon="unfold_more" size="16px"></vs-icon></span>
          </vs-th>
          <vs-th style="padding: 0px"> </vs-th>
        </template>
        <!-- <template slot="thead" >
        
        <vs-th sort-key="name" style="padding: 0px">
          <span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Alert Name
        </vs-th>
        <vs-th sort-key="con" style="padding: 0px">
          <span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Condition
        </vs-th>
        <vs-th sort-key="action" style="padding: 0px">
          <span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Action
        </vs-th>
        <vs-th sort-key="name" style="padding: 0px">
          <span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Active Status
        </vs-th>
        <vs-th sort-key="active" style="padding: 0px">
          <span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Switch ON/OFF
        </vs-th>
        <vs-th  style="padding: 0px">
         
        </vs-th>
      </template> -->

        <template>
          <tbody>
            <tr v-for="(item, i) in action" :key="item.id">
              <td>{{ item.name }}</td>
              <td>
                <p v-for="(condition, index) in item.con" :key="index">
                  {{ condition.con }}:&nbsp;{{ condition.value }}
                </p>
              </td>
              <td>
                <p v-for="(action, index) in item.action" :key="index">
                  {{ action.name }}:&nbsp;{{ action.detail }}:&nbsp;{{
                    action.status
                  }}
                </p>
              </td>
              <td v-if="item.active" @>Active</td>
              <td v-else>Deactive</td>
              <td>
                <vs-switch
                  v-model="switcharray[i]"
                  @click="switch1(switcharray[i], i)"
                >
                  <span slot="on">On</span>
                  <span slot="off">Off</span>
                </vs-switch>
              </td>
              <vs-td :data="item.active">
                <!-- <vs-button class="text-success mr-2 " color="primary" type="flat" icon="add_circle" @click="link2(item)">View</vs-button> -->
                <vs-button
                  class="text-dark mr-2"
                  color="dark"
                  type="flat"
                  icon="content_copy"
                  :disabled="true"
                  >Copy</vs-button
                >
                <vs-button
                  class="text-warning mr-2"
                  color="warning"
                  type="flat"
                  icon="create"
                  @click="edit(item)"
                  >Edit</vs-button
                >
                <vs-button
                  class="text-danger mr-2"
                  color="danger"
                  type="flat"
                  icon="delete"
                  v-b-modal.modal-center
                  @click="id = item.id"
                  >Delete</vs-button
                >
              </vs-td>
            </tr>
          </tbody>
        </template>
      </vs-table>
    </div>
    <b-modal id="modal-center" centered>
      <template #modal-title>
        <b class="text-danger">
          <vs-icon icon="delete" size="small" color="red"></vs-icon>Delete
          Alert</b
        >
      </template>
      <p class="my-4">Do you want to delete alert?</p>

      <template #modal-footer="{ cancel }">
        <!-- Button with custom close trigger value -->
        <b-button id="btncancel" variant="light" @click="cancel()">
          Cancel
        </b-button>
        <vs-button
          color="danger"
          style="border-radius: 20px"
          size="sm"
          @click="del()"
          type="filled"
          >Delete</vs-button
        >
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "actionlist",
  props: ["actionList"],
  watch: {
    switcharray(value) {
      // console.log(value,value.indexOf(value))
    },
  },
  data: () => ({
    nwlist: [],
    header: [
      "Alert Name",
      "Condition",
      "Action",
      "Active Status",
      "Switch ON/OFF",
    ],
    sensorlist: [],
    action: [],
    editaction: {
      name: "",
      con: "",
      type: "",
      sensors: "",
      id: "",
      active: false,
    },
    realaction: [],
    switcharray: [],
    id: ''
  }),
  methods: {
    switch1(bool, i) {
      this.$vs.loading();
      this.action[i].active = !bool;
      this.$http
        .post(this.$url + "activeaction", {
          active: !bool,
          id: this.action[i].id,
        })
        .then(() => {
          this.$vs.notify({
            title: "Update Action",
            text: "Complete!",
            color: "success",
            position: "top-center",
            icon: "check",
          });
          setTimeout(() => {
            this.$vs.loading.close();
          }, 100);
        });
    },
    del() {
      this.$http
        .post(this.$url + "actiondel", {
          id: this.id,
        })
        .then(() => {
          this.$vs.notify({
            title: "Delete Action",
            text: "Complete!",
            color: "danger",
            position: "top-center",
            icon: "check",
          });
        });
      this.$bvModal.hide("modal-center");
    },
    edit(item) {
      this.$session.set("action", "edit");
      this.$session.set("actiondetail", item);
      this.$router.push({
        name: "CreateAction",
      });
    },
    editactionsent() {
      var temp = [];
      temp = this.editaction.sensors.split(", ");
      // eslint-disable-next-line no-console
      // // console.log(temp)
      this.$http
        .post(this.$url + "updateaction", {
          name: this.editaction.name,
          con: this.editaction.con,
          type: this.editaction.type,
          sensors: temp,
          id: this.editaction.id,
          active: this.editaction.active,
          token: this.$session.get("token"),
        })
        .then(() => {
          this.$vs.notify({
            title: "Update Action",
            text: "Complete!",
            color: "success",
            position: "top-center",
            icon: "check",
          });
        });
    },
  },
  created() {
    var temp = [];
    this.action = this.actionList;
    this.action.forEach((element, j) => {
      this.switcharray[j] = element.active;
      element.con.forEach((consen, i) => {
        this.sensorlist.forEach((sensor) => {
          if (sensor.id == consen.sensid) {
            consen.sensid = sensor.name;
          }
        });
      });
      element.action.forEach((action, i) => {
        if (
          (action.detail != "" && action.detail != null) ||
          (action.status != null && action.status != "")
        ) {
          if (action.name == "Work Order")
            temp.push({
              name: "Work Order",
              detail: action.detail.formConfig.headline,
            });
          else if (action.name == "Control" && status)
            temp.push({
              name: "Control",
              detail: action.detail,
              status: "OFF -> ON",
            });
          else if (action.name == "Control" && !status)
            temp.push({
              name: "Control",
              detail: action.detail,
              status: "ON -> OFF",
            });
          else temp.push(action);
        }
      });
      this.$http
        .get(this.$url + "sensorid/" + this.$session.get("token"))
        .then((result) => {
          this.sensorlist = result.data;
          // console.log(this.sensorlist)
          this.action.forEach((element, j) => {
            element.con.forEach((consen, i) => {
              this.sensorlist.forEach((sensor) => {
                if (sensor.id == consen.sensid) {
                  consen.sensid = sensor.name;
                }
              });
            });
          });
        });
      element.action = temp;
      temp = [];
    });
    // console.log(this.realaction)
  },
};
</script>

<style>
a {
  cursor: pointer;
}
.vs-table--not-data {
  font-size: 0%;
}
</style>
<style scoped>
#btncancel {
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}
</style>